/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectRouteUpdatedDtoBase
 * auto generated base class for the model ProjectRouteUpdatedDtoModel.
 *
 * Read only view event
 */
export const ProjectRouteUpdatedDtoModelBase = ModelBase
  .named('ProjectRouteUpdatedDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteUpdatedDto"), "ProjectRouteUpdatedDto"),
    routeId: types.union(types.undefined, types.string),
    /** Route driver's name */
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectRouteUpdatedDtoModelSelector extends QueryBuilder {
  get routeId() { return this.__attr(`routeId`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromProjectRouteUpdatedDto() {
  return new ProjectRouteUpdatedDtoModelSelector()
}

export const projectRouteUpdatedDtoModelPrimitives = selectFromProjectRouteUpdatedDto().routeId.name
